import * as React from 'react';
import * as classNames from 'classnames';
import styled from 'styled-components';
import './styles.scss';

const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
`;

const ReadMore = styled.a`
  cursor: pointer;
`;

const Paragraph = styled.p`
`;

export interface IFormRowProps {
  /** Label to display */
  label?: React.ReactNode;
  /** Error to display */
  error?: React.ReactNode;
  /** Description text to display */
  description?: React.ReactNode;
  /** Width */
  width?: 'default' | 'narrow' | 'wide' | 'max';
  /** Display text value instead of children */
  value?: React.ReactNode;
  /** Show read more */
  showReadMore?: boolean;
  /** HelpText */
  helpText?: string[];
}

interface IState {
  isOpen: boolean;
}

/**
 * Single form row
 */
export default class FormRow extends React.Component<IFormRowProps, IState> {
  static displayName: string = 'FormRow';

  constructor (props: IFormRowProps) {
    super(props);
  }

  state: IState = {
    isOpen: false,
  };

  toggle = () => {
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  };

  render() {
    const { isOpen } = this.state;

    return (
        <div
            className={classNames('form-row', {
              'has-error': this.props.error,
              'has-value': this.props.value,
              'width-default': !this.props.width,
              'width-narrow': this.props.width === 'narrow',
              'width-wide': this.props.width === 'wide',
              'width-max': this.props.width === 'max',
            })}
        >
          {!!this.props.label && (
              <>
                {this.props.showReadMore ? (
                    <Title>
                      <label className='form-row-label'>{this.props.label}</label>
                      <ReadMore onClick={this.toggle}>
                        {isOpen ? 'Hide guideline' : 'Show guideline'}
                      </ReadMore>
                    </Title>
                ) : (
                    <label className='form-row-label'>{this.props.label}</label>
                )
                }

                {isOpen && this.props.helpText &&
                    this.props.helpText.map((paragraph) => (
                        <Paragraph>{paragraph}</Paragraph>
                    ))}
              </>
          )}
          <div className='form-row-main'>
            <div className='form-row-items'>
              {this.props.value !== undefined ? (
                  <div className='form-row-value'>{this.props.value ? this.props.value : '-'}</div>
              ) : (
                  this.props.children
              )}
            </div>
            {((!!this.props.error && typeof this.props.error !== 'boolean') || !!this.props.description) && (
                <div className='form-row-sub'>
                  {this.props.error && <div className='form-row-error'>{this.props.error}</div>}
                  {this.props.description && <div className='form-row-description'>{this.props.description}</div>}
                </div>
            )}
          </div>
        </div>
    );
  }
}
